import { render, staticRenderFns } from "./UnidadSinReporte.vue?vue&type=template&id=47ca0bf5&"
import script from "./UnidadSinReporte.vue?vue&type=script&lang=js&"
export * from "./UnidadSinReporte.vue?vue&type=script&lang=js&"
import style0 from "./UnidadSinReporte.vue?vue&type=style&index=0&id=47ca0bf5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports